const $$splitComponentImporter = () => import('/app/frontend/src/routes/_auth/server-error.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { routeForState } from '@/features/auth/model/state-route';
export const Route = createFileRoute('/_auth/server-error')({
  staticData: {
    backgroundImage: '/login_background.jpg'
  },
  beforeLoad: async ({
    context
  }) => {
    const {
      frontendUserState
    } = await context.ensureProfile();
    if (routeForState(frontendUserState) !== '/server-error') {
      throw redirect({
        to: '/'
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});